<template>
  <div class="problemHeader-page">
    <div class="problemHeader-left">政策协议</div>
    <div class="problemHeader-right"></div>
  </div>
</template>
<script setup lang="ts" name="CompHeader"></script>
<style scoped lang="scss">
.problemHeader-page {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 40px;
  .problemHeader-left {
    font-size: 32px;
    font-weight: 700;
    color: rgba(49, 62, 82, 1);
  }
  .input-with-select {
    width: 400px;
    height: 44px;
  }
  .problemHeader-search {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 44px;
    img {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
<style lang="scss">
.problemHeader-page {
  .el-input-group__append {
    width: 56px;
    height: 44px;
    padding: 0;
    cursor: pointer;
    background: rgba(51, 133, 255, 1);
  }
}
</style>
